import React, { useState, useEffect } from "react";
import { useFormContext } from "../createworkflow/FormContext";
import { ErrorBoundary } from "../common/ErrorBoundary";
import Loader from "../common/Loader";
import className from './Stage5.module.css';

export default function Stage5() {
  const { formData, updateFormData } = useFormContext();
  const [dataFrequency, setDataFrequency] = useState(formData?.stage2.forecast_frequency || '');
  const [dataList, setDataList] = useState([]);
  const fileObject = [{
    "title": "Forecast model file",
    "sample-file-path": "/sample_files/ForecastSheet.csv",
    "sheetname": "ForecastFile"
  }]

  useEffect(()=>{
    try{
      let _data = formData?.stage5?.seasonality_data;
      if(_data != null ){
        setDataList(Object.entries(formData?.stage5?.seasonality_data));
      }
    }catch(error){
      
    }


    // if(dataFrequency.toLowerCase() === 'weekly'){
    //   const Weeks = Array.from({length:52},(_,i)=> `Week ${i+1}`);
    //   setDataList(Weeks);
    // }
    // else{
    //   const months = Array.from({ length: 12 }, (_, i) =>
    //     new Date(0, i).toLocaleString("en-US", { month: "long" })
    //   );
    //   setDataList(months)
    // }
  },[])

  const handleFileUploadClick = () => {

  }

  const handleSeasonalInputItemOnChange = (e) => {
    const { id, value } = e.target;
    // if(typeof value !== 'number'){
    //   return;
    // }
    updateFormData("stage5", {
      ...formData.stage5,
      seasonality_data: {
        ...formData.stage5.seasonality_data,
        [id]: Number(value), 
      },
    });
  }

  console.log(dataList)
  return (
    <ErrorBoundary>
      <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 stage5" >
          <div class="createworkflowtabcontents">
            <div id="stage5">
              <div class="col-md-3 col-sm-3 col-xs-12">
                <div className={className["stage5-table"]}>
                  <table className="table promotiontable table-bordered">
                    <thead>
                    <tr>
                      <td>Seasonality {dataFrequency}</td>
                      <td> Value </td>
                      </tr>
                    </thead>
                    <tbody>
                      {dataList?.map(([key,value]) => (<tr key={key}>
                        <td>{key}</td>
                        <td className={className.toggle}> 
                          <input 
                          type="number" 
                          step="any" 
                          id={key}
                          defaultValue={value}
                          min={0} 
                          max={1}
                          onChange={handleSeasonalInputItemOnChange}
                          /> </td>
                      </tr>)
                      )}
                    </tbody>
                  </table>
                </div>
                </div>
                 <div class="col-md-1 col-sm-1 col-xs-12">

                 </div>
                <div class="col-md-5 col-sm-5 col-xs-12">
                      
                <div className="form-group1">
                <h1>Seasonality Changes File Upload</h1>      
                  <label htmlFor="file1">{fileObject.title}</label>
                  <input
                    id={`seasonal-file`}
                    type="file"
                    className={`form-control ${formData.stage5?.file_upload_status?.error ? "highlighted" : ""}`}
                    accept=".csv, .xlsx, .xls"
                    placeholder="No File Choosen"
                  />
                </div>
                <div className="choosefilediv">
                  <ul>
                    <li>
                      <a
                        className="lblinfo download-link"
                        href={process.env.REACT_APP_SAMPLE_EXOG_FILE_PATH}
                        download={true}
                      >
                        <iconify-icon icon="material-symbols:download"></iconify-icon>{" "}
                        <span className="lblinfo"> Download Sample File</span>
                      </a>
                    </li>
                    <li className="lblinfo">(File Type: XLS | XLSX | CSV)</li>
                    <li
                      className={`lblerror ${formData.stage5?.file_upload_status?.error ? "visible" : "hidden"
                        }`}
                    >
                      {" "}
                      * Required
                    </li>
                    <li
                      className={`lblsuccess ${formData.stage5?.file_upload_status?.success ? "visible" : "hidden"
                        }`}
                    >
                      {" "}
                      File has been uploaded
                    </li>
                    {formData.stage5?.file_upload_status?.isLoading &&
                      <li><Loader size="small" /></li>
                    }
                  </ul>
                </div>
                <div className="form-group1">
              <div className="uploadbtn">
                <a
                  href="#"                  
                  // data-fileid={`seasonality_file`}
                  // data-sheetname={elem.sheetname}
                  onClick={(e) => {
                    e.preventDefault();
                    handleFileUploadClick(e);
                  }}
                >
                  Upload File{" "}
                  <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                </a>
              </div>
            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
